import * as React from 'react'
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import './PromocodeList.css'
import { PromocodeConfig } from '../../../configs/stream-entities'

class PromocodeListProps {
    public isMultiple: boolean = false
    public defaultValue: string = ''
    public onItemSelected: (doc: any) => void
}

class PromocodeListState {
    public types: string[] = []
    public defaultValue: string = '-1'
}

class PromocodeList extends React.Component<PromocodeListProps, PromocodeListState> {
    private classTypeIdList: string[] = []
    private classTypeList: any[] = []

    constructor(props: PromocodeListProps) {
        super(props)
        const newState = new PromocodeListState()
        newState.defaultValue = this.props.defaultValue
        this.state = newState
        this.onItemSelected = this.onItemSelected.bind(this)
    }

    public componentWillMount() {
        firebase.firestore().collection('promocodes').orderBy('code', 'asc').onSnapshot(snapshot => {
            snapshot.docChanges().forEach(query => {
                const newClass = new PromocodeConfig()
                Object.assign(newClass, query.doc.data()!)
                newClass.id = query.doc.id

                if (this.classTypeIdList.indexOf(query.doc.id) > -1) {
                    const index = this.classTypeIdList.indexOf(query.doc.id)
                    this.state.types[index] = newClass.code
                } else {
                    this.classTypeIdList.push(newClass.id)
                    this.classTypeList.push(newClass)
                    this.state.types.push(newClass.code)
                }
                this.setState(this.state)
            })
        })
    }

    public render() {
        return (<select className="PromocodeList" onChange={this.onItemSelected} multiple={this.props.isMultiple} value={this.props.isMultiple? [this.getSelectDefaultValue()] : this.getSelectDefaultValue()} required={true}>
            <option value="">Select a Promocode</option>
            {this.state.types.map((q, i) =>
                <option key={i} value={i}>{q}</option>
            )}
        </select>)
    }

    private getSelectDefaultValue(): string {
        for (let i = 0; i < this.classTypeList.length; i++) {
            if (this.classTypeList[i].id === this.state.defaultValue) {
                return String(i)
            }
        }
        return '-1'
    }

    private onItemSelected(event: React.ChangeEvent<HTMLSelectElement>) {
        const index = Number(event.currentTarget.value)
        if (index > -1) {
            const doc = this.classTypeList[index]
            this.props.onItemSelected(doc)
            this.setState({ defaultValue: doc.id })
        }
    }

}

export default PromocodeList


// WEBPACK FOOTER //
// ./src/components/promocode/promocode-list/PromocodeList.tsx